import { Check, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

const ABOUT_IMG =
    "https://images.pexels.com/photos/17489150/pexels-photo-17489150.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const POINTS = [
    "Post-quantum readiness assessments, engineered in Bengaluru",
    "847 detection patterns across 28 programming languages",
    "Discovery, risk scoring and migration roadmaps in one platform",
];

export const About = () => (
    <section id="about" data-testid="about-section" className="relative py-24 sm:py-32">
        <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
            <Reveal className="relative order-2 lg:order-1">
                <div className="relative">
                    <div className="absolute -inset-4 rounded-3xl bg-volt/5 blur-2xl" />
                    <div className="relative overflow-hidden rounded-2xl border border-white/10">
                        <img
                            src={ABOUT_IMG}
                            alt="Syntera AI infrastructure engineers at work"
                            className="h-[420px] w-full object-cover transition-transform duration-700 hover:scale-105"
                            data-testid="about-image"
                        />
                        <div className="absolute inset-0 bg-gradient-to-tr from-[#07090E]/70 via-transparent to-transparent" />
                    </div>
                    <div className="absolute -bottom-6 -right-4 rounded-xl border border-white/10 bg-[#0D111A]/95 px-6 py-4 backdrop-blur-xl sm:-right-8">
                        <div className="font-syne text-3xl font-extrabold text-volt">2026</div>
                        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">
                            Founded in Bengaluru
                        </div>
                    </div>
                </div>
            </Reveal>

            <div className="order-1 lg:order-2">
                <Reveal>
                    <Eyebrow>About Us</Eyebrow>
                    <h2 className="mb-6 font-syne text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl" data-testid="about-heading">
                        AI-Driven. Cloud-Ready.{" "}
                        <span className="bg-gradient-to-r from-volt to-blue-500 bg-clip-text text-transparent">
                            Future-Focused.
                        </span>
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <p className="text-base leading-relaxed text-slate-400 sm:text-lg" data-testid="about-body">
                        Syntera Technologies is a product company founded in 2026 in Bengaluru,
                        India's technology capital. We build post-quantum security software that
                        finds the cryptography a quantum computer will break, scores the risk,
                        and plans the migration to quantum-safe algorithms, system by system,
                        for Indian enterprises, banks and public sector undertakings.
                    </p>
                </Reveal>
                <Reveal delay={0.2}>
                    <ul className="mt-8 space-y-3.5">
                        {POINTS.map((p) => (
                            <li key={p} className="flex items-start gap-3 text-sm text-slate-300 sm:text-base">
                                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-volt/15">
                                    <Check size={12} className="text-volt" />
                                </span>
                                {p}
                            </li>
                        ))}
                    </ul>
                </Reveal>
                <Reveal delay={0.3}>
                    <button
                        data-testid="about-know-more-btn"
                        onClick={() => scrollToId("#capabilities")}
                        className="group mt-9 inline-flex items-center gap-2 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-volt transition-colors hover:text-white"
                    >
                        Know More
                        <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </button>
                </Reveal>
            </div>
        </div>
    </section>
);
